import './sponsorblock.less'

import {Image} from '@codeurs/front'
import React from 'react'
import {ImageType, LinkType, WysiwygType} from 'types'
import {Link} from 'util/link'
import {style} from 'util/style'
import {Theme} from 'views/theme'

const styles = style('sponsorblock', ['items'])

export type SponsorblockType = {
	image?: ImageType
	title?: string
	website?: LinkType
	text?: WysiwygType
}

export const Sponsorblock: React.FC<SponsorblockType> = ({
	image,
	title,
	website,
	text
}) => {
	return (
		<div className={styles()}>
			<Theme.OuterContainer>
				<Theme.Container>
					{image && (
						<Link to={website && website.url} className={styles('logo')}>
							<Image {...image} />
						</Link>
					)}
					{title && <Theme.H3 className={styles('title')}>{title}</Theme.H3>}
					{website && (
						<div className={styles('link')}>
							<Link to={website.url} className={styles('link-label')}>
								{website.description || website.title}
							</Link>
						</div>
					)}
					{text && (
						<div className={styles('text')}>
							<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
						</div>
					)}
				</Theme.Container>
			</Theme.OuterContainer>
		</div>
	)
}
